import { render } from "./SidebarNavigation.vue?vue&type=template&id=ae8c3e66&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=ae8c3e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8c3e66"]])

export default __exports__